import React, { useEffect, useState } from 'react';
import SendEmail from '../components/SendEmail';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetchPaymentMadeDetails, sendEmail } from '../../services/payment_made';
import PageLoader from '../../component/PageLoader';
import { useSelector } from 'react-redux';

function PurchaseMadeSendEmail() {
	const navigate = useNavigate();
	const params = useParams();
	const { id } = params;
	const { userInfo } = useSelector((state) => state);
	const [paymentMadeDetails, setPaymentMadeDetails] = useState({});
	const suburl = localStorage.getItem('suburl');
	const [toEmails, setToEmails] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [emailFormData, setEmailFormData] = useState({
		payment_made_id: null,
		payment_number: '',
		from: '',
		to: [],
		subject: '',
		body: '',
		isAttachment: true,
	});

	async function handleSend(formData) {
		try {
			await sendEmail(formData);
			toast.success('Email Sent Successfully.');
			navigate(`/user/${suburl}/payment-made`);
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	function handleClose() {
		navigate(`/user/${suburl}/payment-made`);
	}

	async function handleFetchPaymentMadeDetails() {
		try {
			setIsLoading(true);
			const data = await fetchPaymentMadeDetails(id);
			setPaymentMadeDetails(data);
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setIsLoading(false);
		}
	}

	useEffect(() => {
		if (id) {
			handleFetchPaymentMadeDetails();
		} else {
			navigate(`/user/${suburl}/purchases-made`);
		}
	}, [id]);

	useEffect(() => {
		if (paymentMadeDetails && userInfo) {
			const { payment_made_id, payment_number, vendor } = paymentMadeDetails;
			const vendorContactEmailList = Array.from(
				new Set(
					(vendor?.contact_person || [])
						.filter((contact) => contact?.email)
						.map((contact) => contact.email),
				),
			);

			// const vendorContactEmailList =
			// 	vendor?.contact_person && vendor?.contact_person?.length > 0
			// 		? vendor?.contact_person
			// 				?.filter((contact) => {
			// 					if (contact?.email) {
			// 						return contact;
			// 					}
			// 				})
			// 				.map((contact) => {
			// 					return contact?.email;
			// 				})
			// 		: [];
			setEmailFormData((prev) => ({
				...prev,
				to: vendorContactEmailList,
				from: `${userInfo?.userInfo?.data?.first_name} ${userInfo?.userInfo?.data?.last_name}`,
				payment_made_id,
				payment_number,
				subject: `Payment Made from ${userInfo?.userInfo?.data?.first_name + ' ' + userInfo?.userInfo?.data?.last_name} (Payment Made Number #: ${payment_number})`,
			}));
			setToEmails(vendorContactEmailList);
		}
	}, [paymentMadeDetails, userInfo]);

	if (isLoading) {
		return <PageLoader />;
	}

	return (
		<div>
			<SendEmail
				pdfName="Payment Made"
				pdfId={`${paymentMadeDetails?.payment_number}`}
				toEmails={toEmails}
				formData={emailFormData}
				handleSend={handleSend}
				handleClose={handleClose}
			/>
		</div>
	);
}

export default PurchaseMadeSendEmail;
